import { useTranslation } from "react-i18next";
import { Banner, Button, typography } from "@dsaui/components";
import { XCircle as ErrorCircle } from "@dsaui/icons";

interface AuthenticationErrorPageProps {
  onRetry: () => void;
}

const AuthenticationErrorPage = ({ onRetry }: AuthenticationErrorPageProps) => {
  const { t } = useTranslation();

  return (
    <div className="bg-gray-50 px-4 py-10 sm:px-6 sm:py-12">
      <div className="mx-auto flex w-full max-w-2xl flex-col gap-5">
        <Banner
          bodyClassName={typography.notificationErrorBody.className}
          icon={<ErrorCircle className="size-5" />}
          role="alert"
          title={t("login.error.title")}
          titleClassName={typography.notificationErrorHeading.className}
          variant="error"
        >
          <p className="m-0">{t("login.error.body")}</p>
        </Banner>
        <div>
          <Button onClick={onRetry}>{t("login.error.action")}</Button>
        </div>
      </div>
    </div>
  );
};

export default AuthenticationErrorPage;
